<template>
  <h-tour-dialog v-model="show">
    <p class="text-center text-h6 mx-6" v-text="__('tour0')" />
    <div class="my-6 text-center"><v-icon x-large v-text="icons.tap" /></div>
  </h-tour-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HTourDialog from './Dialog'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HTourDialog,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
    },

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
    },
  }
</script>
